import { Component } from '@angular/core';
import { BlurComponent } from './blur.component';

@Component({
  selector: 'eid-blur-desktop',
  templateUrl: './blur.desktop.component.html',
  styleUrls: ['./blur.desktop.component.scss']
})
export class BlurDesktopComponent extends BlurComponent {}
